import { render, staticRenderFns } from "./admin-bind-dialog.vue?vue&type=template&id=dec565fc&"
import script from "./admin-bind-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-bind-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports